import { render, staticRenderFns } from "./EditCustomPushNotification.vue?vue&type=template&id=79909164&"
import script from "./EditCustomPushNotification.vue?vue&type=script&lang=js&"
export * from "./EditCustomPushNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports